import React, { PureComponent } from "react";
import { t } from "./i18n";

class NearCloseLottoList extends PureComponent {
  componentDidUpdate(prevProps) {
  if (prevProps.openItems !== this.props.openItems) {
    // console.log(
    //   `[NearCloseLottoList] openItems ref changed | prev=${(prevProps.openItems || []).length} next=${(this.props.openItems || []).length}`
    // );
  }

  if (prevProps.countdowns !== this.props.countdowns) {
   // console.log("[NearCloseLottoList] countdowns ref changed");
  }

  if (prevProps.maxRows !== this.props.maxRows) {
    //console.log(`[NearCloseLottoList] maxRows changed ${prevProps.maxRows} -> ${this.props.maxRows}`);
  }
}
  render() {
    const {
      openItems = [],
      maxRows = 10,
      countdowns = {},
      redeemlotto,
    } = this.props;

    const lang = localStorage.getItem("lang") || "th";

    const renderStart = performance.now();

    const filledRows = openItems
      .slice(0, maxRows)
      .map((item, index) => (
        <div
          key={item.roomid || `${item._id || "row"}-${index}`}
          style={{ width: "100%", height: "auto" }}
          className="ng-star-inserted"
        >
          <div
            className={`row mx-3 mt-2 mb-0 ${
              index === 0
                ? "bg-near-close-lotto-detail"
                : "bg-near-close-lotto-detail-white"
            }`}
          >
            <div className="col-7 ng-star-inserted">
              <div className="row">
                <div
                  className={`${
                    index === 0
                      ? "remain-left-red col-6 py-1 px-1 ng-star-inserted"
                      : "remain-time-main col-6 py-1 px-1 ng-star-inserted"
                  }`}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    style={{
                      width: "20px",
                      height: "20px",
                      marginRight: "4px",
                    }}
                  >
                    <circle cx="12" cy="13" r="8" />
                    <line x1="12" y1="13" x2="12" y2="9" />
                    <line x1="12" y1="13" x2="15" y2="15" />
                    <path d="M5 3 2 6" />
                    <path d="M22 6l-3-3" />
                  </svg>
                  {countdowns[item.roomid] || t(lang, "loading")}
                </div>

                <div
                  className={`pl-1 col-6 pl-2 ${
                    index === 0
                      ? "lotto-name-main-white ng-star-inserted"
                      : "lotto-name-main-black ng-star-inserted"
                  }`}
                >
                  {item.name}
                </div>
              </div>
            </div>

            <a
              onClick={(e) =>
                redeemlotto && redeemlotto(e, item._id, item.roomid)
              }
              role="button"
              className="image-btn-effect2 col-5 px-0 ng-star-inserted"
              style={{ alignSelf: "center" }}
            >
              <div
                className="row ng-star-inserted"
                style={{ justifyContent: "right" }}
              >
                <div
                  className="col-3 px-0 ng-star-inserted"
                  style={{
                    alignSelf: "center",
                    textAlign: "right",
                  }}
                >
                  <img
                    className="flag-near-close-lotto"
                    src={item.flagimage}
                    alt={item.name}
                  />
                </div>

                <div
                  className={`col-5 px-3 mx-3 ${
                    index === 0
                      ? "bg-link-product-main image-btn-effect2"
                      : "bg-link-product-main-green"
                  }`}
                >
                  <div role="button" className="px-0 flag-word-main">
                    {t(lang, "lt_bet_now")}
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>
      ));

    const renderEnd = performance.now();
    // console.log(
    //   `[NearCloseLottoList] render: ${(renderEnd - renderStart).toFixed(
    //     2
    //   )} ms | openItems=${openItems.length} | rendered=${Math.min(
    //     openItems.length,
    //     maxRows
    //   )}`
    // );

    return <>{filledRows}</>;
  }
}

export default NearCloseLottoList;